import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccountingDocument = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "accounting-document" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.75,21.75a1.5,1.5,0,0,1-1.5,1.5H3.75a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,3.75.75H14.379a1.5,1.5,0,0,1,1.06.439l5.872,5.872a1.5,1.5,0,0,1,.439,1.06Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.75,8.25h-6a1.5,1.5,0,0,1-1.5-1.5v-6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6.2,11.594a2.224,2.224,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547S9.2,9.376,8.062,9.376,6,8.683,6,7.828s.924-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.062,
			y1: 12.469,
			x2: 8.062,
			y2: 13.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.062,
			y1: 5.25,
			x2: 8.062,
			y2: 6.281
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 15,
			x2: 18,
			y2: 15
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6.75,
			y1: 19.5,
			x2: 18,
			y2: 19.5
		})
	]
});
export default SvgAccountingDocument;
